import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import { Calendar } from 'primereact/calendar';
import { InputMask } from 'primereact/inputmask';
import moment from "moment";
import { Dropdown } from 'primereact/dropdown';

const CandidateEducationFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const qualification = [
    {label: 'Általános iskola', value: 'ELEMENTARY_SCHOOL'},
    {label: 'Középiskola', value: 'HIGH_SCHOOL'},
    {label: 'BSC', value: 'BSC'},
    {label: 'MSC', value: 'MSC'}
  ]

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().candidateEducationId) || (entity === 'candidate-education' && id)) {
      const payload = {
        ...formData,
        ...newFormData,
        candidate: Number(props.candidateId)
      }
      apiCall('patch', '/api/v2/candidate-education/' + (window.App.urlVars().candidateEducationId ?? id), payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderCandidateEducationList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      const payload = {
        ...data,
        candidate: Number(props.candidateId)
      }
      apiCall('post', '/api/v2/candidate-education', payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderCandidateEducationList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push(`/recruitment/candidate/read/${id}/candidate-education/update/` + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().candidateEducationId) || (entity === 'candidate-education' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/candidate-education/' + (window.App.urlVars().candidateEducationId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"candidate-education-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            {/* <div className={"p-col-12 p-lg-6"}>
              <Field name="level" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="level"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldLevel')}</label>
                  <span className="p-d-block">
                      <InputText id="level" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     level: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     level: e.target.value
                                   })
                                 }}
                                 value={formData.level}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div> */}

            <div className={"p-col-12 p-lg-6"}>
              <Field name="school" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="school"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldSchool')}</label>
                  <span className="p-d-block">
                      <InputText id="school" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     school: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     school: e.target.value
                                   })
                                 }}
                                 value={formData.school}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-6"}>
              <Field name="level" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="level"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldEducationLevel')}</label>
                  <span className="p-d-block">
                      <Dropdown id="level"
                                options={window.App.sortDropdownOptions(qualification, "label")}
                                optionLabel="label"
                                 placeholder={t('selectPlaceholder')}onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     level: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     level: e.target.value
                                   })
                                 }}
                                 value={formData.level}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


            <div className={"p-col-12 p-lg-6"}>
              <Field name="end_date" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="end_date"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldEducationCompletionDate')}</label>
                  <div className="p-inputgroup calendar-icon-only">
                    <InputMask id={"end_date"}
                                mask={"9999-99-99"}
                                placeholder={t('datePlaceholder')}
                                value={moment.utc(formData.end_date || null).local().format('YYYY-MM-DD')}
                                onChange={(e) => {
                                  if (e.value.indexOf("_") === -1) {
                                    if (e.value === '') {
                                      e.value = null
                                    }
                                    setFormData({
                                      ...formData,
                                      end_date: new Date(e.value)
                                    })
                                    setNewFormData({
                                      ...newFormData,
                                      end_date: new Date(e.value)
                                    })
                                  }
                                }}
                      />
                      <Calendar value={formData.end_date}
                                  dateFormat={'yy-mm-dd'}
                                  showIcon
                                  locale='hu'
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     end_date: e.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     end_date: e.value
                                   })
                                 }}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </div>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'candidate-education' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(CandidateEducationFormComponent);
